import {useState} from "react";
import {useInventory} from "../../context/InventoryContext";
import useToggle from "../../shared/functions/useToggle";
import {Avatar, Stack, Typography, Chip} from "@mui/material";
import AntDataGrid from "../../shared/components/AntDataGrid";
import InventoryDataGridToolbar from "./OrderingDataGridToolbar";
import OrderingDetails from "./OrderingDetails";

const columns = [
    {
        title: 'Image', dataIndex: 'ImageUrl', key: 'ProductImageUrl',
        render: (image) => {
            return (
                <>
                    {
                        image
                            ? <Avatar alt={'...'} src={image}/>
                            : <Avatar>no</Avatar>
                    }
                </>
            )
        }
    },

    {
        title: 'Name', dataIndex: 'Name', key: 'Name',
        render: (val, {IsParent, HasChilds}) => {

            const ft = text => (text || '')?.trim()?.toLowerCase()

            const list = ['pack', ' pac ', ' pak ', ' pk '];

            let flag = ((IsParent || [])?.length > 0) || (HasChilds) || false

            list.forEach(label => {
                if (ft(val)?.includes(label))
                    flag = true
            })

            return (
                <Stack direction={'row'} spacing={1}>
                    <Typography>
                        {val}
                    </Typography>

                    {flag && (<Chip color={'success'} label={'Pk'}/>)}

                </Stack>
            )
        }
    },

    {
        title: 'Qt. to purchase', dataIndex: '_', key: 'Stock',
        render: (_, {QuantityToBuy}) => QuantityToBuy
    },
    {
        title: 'ITEM CODE', dataIndex: '_', key: 'ItemCode',
        render: (_, {ItemCode}) => ItemCode
    },


];


export default function OrderingDataGrid () {
    const {data, loading, loadMore} = useInventory();
    const {open, handleOpen, handleClose} = useToggle()
    const [selected, setSelected] = useState(); 

    const handleSelection = record => {
        setSelected(record)
        handleOpen();
    }
    // const handleOneSelection = record => {
    //     setSelected(record)
    //     handleOpen();
    // }

    const handleDetailModalClosing = () => {
        setSelected(null)
        handleClose()
    }

    const handlePageChange = (current, total) => (current === (total - 1) || current === total) && loadMore()
     

    return (
        <>
        <AntDataGrid 
                data={data}
                columns={columns} 
                isLoading={loading} 
                ToolBar={InventoryDataGridToolbar} 
                onPageChange={handlePageChange} 
                doubleClickAction={handleSelection} 
                shadows
            />
           

            {
                selected && (
                    <OrderingDetails 
                        data={data}
                        open={open} 
                        item={selected} 
                        onClose={handleDetailModalClosing} 
                    />
                )
            } 
        </>
    )

}